import { useEffect, useRef, useState } from "react";

export default function FinalCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative py-32 md:py-44 overflow-hidden" ref={ref}>
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Tibetan%20dzi%20beads%20natural%20crystal%20jade%20bracelet%20energy%20jewelry%20collection%20on%20warm%20golden%20sand%20surface%20with%20soft%20bokeh%20background%20luxury%20oriental%20aesthetic%20warm%20amber%20tones%20serene%20peaceful%20spiritual%20beauty%20high%20end%20photography&width=1920&height=900&seq=cta_bg001&orientation=landscape"
          alt="最終CTA背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e1a16]/70 via-[#1e1a16]/60 to-[#1e1a16]/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-16 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {/* Decorative */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="w-12 h-px bg-[#c9a96e]"></span>
            <i className="ri-sparkling-2-line text-[#c9a96e] text-xl"></i>
            <span className="w-12 h-px bg-[#c9a96e]"></span>
          </div>

          <h2
            className="text-white font-bold mb-6 leading-[1.35]"
            style={{
              fontSize: "clamp(1.5rem, 3.5vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            找到屬於你的守護能量
          </h2>

          <p
            className="text-white/75 leading-[1.75] mb-12 max-w-2xl mx-auto"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            讓天珠、礦石與文化藝術飾品所蘊含的自然能量與祝福，
            <br className="hidden md:block" />
            陪伴你走過人生的每一段旅程。
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => handleScroll("#products")}
              className="px-10 py-4 bg-[#c9a96e] text-[#1e1a16] rounded-full text-[1rem] font-semibold tracking-widest cursor-pointer hover:bg-[#b8945a] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              探索能量系列
            </button>
            <button
              onClick={() => handleScroll("#featured")}
              className="px-10 py-4 bg-white/15 backdrop-blur-sm text-white border border-white/40 rounded-full text-[1rem] font-medium tracking-widest cursor-pointer hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              立即選購
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
